import { NotesTabSection } from './NotesTabSection';

export default NotesTabSection;
